import { SgdsTextarea } from './sgds-textarea.js';

customElements.define("sgds-textarea", SgdsTextarea);
//# sourceMappingURL=index.js.map
